<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            new fields.Input({
              label: 'Nazwa robocza',
              modelPath: [this, 'form', 'working_name']
            }),
            new fields.Switch({
              label: 'Ciemne tło',
              modelPath: [this, 'form', 'is_dark']
            }),
            new fields.Header({
              text: 'Pierwsza kolumna',
              type: 'h3'
            }),
            new fields.Input({
              label: 'Indeks 1',
              modelPath: [this, 'form', 'index_first'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Tytuł 1',
              modelPath: [this, 'form', 'title_first'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Treść 1',
              modelPath: [this, 'form', 'content_first'],
              multilingual: true,
              required: true
            }),
            new fields.Header({
              text: 'Druga kolumna',
              type: 'h3'
            }),
            new fields.Input({
              label: 'Indeks 2',
              modelPath: [this, 'form', 'index_second'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Tytuł 2',
              modelPath: [this, 'form', 'title_second'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Treść 2',
              modelPath: [this, 'form', 'content_second'],
              multilingual: true,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
